import { render, staticRenderFns } from "./UsersMobileView.vue?vue&type=template&id=836d7922&"
import script from "./UsersMobileView.vue?vue&type=script&lang=js&"
export * from "./UsersMobileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports